import { _transformProject } from '@shared/datastore/projects';
import { TypedAction } from '../actions';
import {
  mergeEntities,
  mergeWebsocketEntities,
  transformObjects,
} from '../store.helpers';

export function threadProjectsReducer(state = {}, action: TypedAction) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'threads') {
        const contextDetails = action.payload.result.context_details;
        if (!contextDetails || !contextDetails.projects) {
          return state;
        }

        const { ref } = action.payload;

        return mergeWebsocketEntities<'threadProjects'>(
          state,
          transformObjects(
            Object.values(contextDetails.projects),
            _transformProject,
          ),
          {
            path: ['threadProjects', ref.path[1], undefined],
          },
        );
      } else if (action.payload.type === 'threadProjects') {
        const { result, ref } = action.payload;
        if (result.projects) {
          return mergeEntities<'threadProjects'>(
            state,
            transformObjects(Object.values(result.projects), _transformProject),
            ref,
          );
        }
        return state;
      }
      return state;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/thread/threadProject.reducer.ts